import React from 'react'

import styles from './BlockItem.module.scss'

const BlockItem = ({ name, value }) => (
    <li className={styles.blockItem}>
        {!!name && <span>{name}: </span>}
        {value}
    </li>
)

export default BlockItem
